<template>
  <div>
    <carousel :perPage="1">

      <slide>
        <div class="padding">
        <p>i made another map for Oska this week, he said he didn't need one, that he knows how to make his own now, that no one else's mothers were making them. He's probably right.</p>
        </div>
      </slide>

      <slide>
        <div class="padding">
        <p>I've made this city black from all the ink i've tried to seal it in.</p>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'Ink'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
